<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">
                    <card>
                        <h5 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span>
                            - Новый отчет</h5>
                        <form>
                            <div class="row">
                                <div class="loader" v-if="waiting"></div>

                                <div class="col-md-8 buttons-block">
                                    <div>
                                        <h4 slot="header" class="card-title">
                                            Отчет все страны и регионы (один файл, txt): <span v-if="data.reports_src">
                                            <span class="inline-link">
                                                <a :href="data.reports_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h4>

                                        <div>
                                            <input ref="reportsFileInput" class="btn-file" type="file"
                                                   @change="uploadFile($event, 'reports_src')">
                                            <button type="submit" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.reportsFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <h4 slot="header" class="card-title">
                                            Отчет Бразилия (txt): <span v-if="data.reportsBRL_src">
                                            <span class="inline-link">
                                                <a :href="data.reportsBRL_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h4>

                                        <div>
                                            <input ref="reportsBRLFileInput" class="btn-file" type="file"
                                                   @change="uploadFile($event, 'reportsBRL_src')">
                                            <button type="submit" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.reportsBRLFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <h4 slot="header" class="card-title">
                                            Курсы валют (csv): <span v-if="data.rates_src">
                                            <span class="inline-link">
                                                <a :href="data.rates_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h4>

                                        <div>
                                            <input ref="ratesFileInput" class="btn-file" type="file"
                                                   @change="uploadFile($event, 'rates_src')">
                                            <button type="submit" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.ratesFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="data.revenue > 0">
                                    <div>My Feed: {{ data.revenue_0 }} $</div>
                                    <div>Muse: {{ data.revenue_1 }} $</div>
                                    <div>Wallpapers: {{ data.revenue_2 }} $</div>
                                    <div>Imagine: {{ data.revenue_3 }} $</div>
                                    <div>Framy: {{ data.revenue_4 }} $</div>
                                    <div>---</div>
                                    <div>Общий доход: {{ data.revenue }} $</div>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!data.reports_src || !data.rates_src"
                                        @click.prevent="upload">
                                    Загрузить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    name: 'CreateAlbum',
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            data: {
                reports_src: null,
                reportsBRL_src: null,
                rates_src: null,
                revenue: 0,
                revenue_0: 0,
                revenue_1: 0,
                revenue_2: 0,
                revenue_3: 0,
                revenue_4: 0,
            },
        }
    },
    created: function () {

    },
    methods: {
        goBack: function () {
            window.history.back();
        },
        upload: function () {
            let self = this;

            let data = JSON.parse(JSON.stringify(this.data));

            self.waiting = true;

            axios.post(
                `${this.$hostname}/admin/reports/parse`,
                data,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {
                    self.waiting = false;

                    let id = response.data.id

                    self.$router.push('/reports/');
                })
                .catch(function (error) {
                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    self.waiting = false;
                });
        },
        uploadFile: function (event, type) {

            let self = this;

            let formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            axios.post(
                `${this.$hostname}/admin/reports/file/upload`,
                formData,
                {
                    params: {
                        file_type: type,
                        reports: true
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {

                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                self.data[data.file_type] = data.url;
                self.data[data.file_type + '_full'] = data.url_full;
            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },
    }
}

</script>
<style scoped>
button:disabled,
button[disabled] {
    cursor: not-allowed;
}

.btn-save {
    width: 150px;
}

.buttons-block {
    padding-left: 20px !important;
}

.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.checkbox-block {
    margin-top: 40px;
    margin-left: 40px;
}

.btn-file {
    display: none;
}
.label-checkbox {
    cursor: pointer;
}
.inline-link span {
    padding: 3px;
    border-radius: 4px;
    font-size: 18px;
}

.bg-danger {
    background-color: rgba(255, 70, 50, 0.5) !important;
}
.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
}

.label-checkbox {
    margin-right: 10px
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    /*margin-top: 15px;*/
}

/* Customize the label (the container) */
.container {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #ccc;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
    opacity: 0.8;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
    background-color: #54abfe;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.preview-device {
    display: inline-block;
    width: 32%;
    margin-left: 10px;
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.device-block.inactive {
    opacity: 0.5;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device1 {
    display: inline-block;
    /*width: 281px;*/
    /*height: 609px;*/
    width: 337px;
    height: 731px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 40px;
}

.device2 {
    display: inline-block;
    /*width: 310px;*/
    /*height: 552px;*/
    width: 372px;
    height: 662px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.device3 {
    display: inline-block;
    /*width: 384px;*/
    /*height: 640px;*/
    width: 461px;
    height: 614px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.mt30 {
    margin-top: 30px;
}

#ajaxForm, ajaxForm2, ajaxForm3 {
    position: relative;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}
.buttons-block h4 {
    margin-top: 20px;
}
.buttons-block h4:first-child {
    margin-top: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Create.vue